// FUN — zábavní sekce oddělená od manažerské analytiky.
import React from "react";
import { Link } from "react-router-dom";
import { GameController, PuzzlePiece, CalendarCheck, Storefront, Trophy, Sword, ArrowsDownUp, Tag, Binoculars } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";

const GAMES = [
    { to: "/inko", label: "INKO", icon: PuzzlePiece, text: "Poznej hráče z 6 postupně odhalovaných indícií. 200 hráčů, současnost i FPL legendy.", live: true },
    { to: "/inko/daily", label: "INKO Daily", icon: CalendarCheck, text: "Wordle-style denní výzva — jeden hráč denně pro všechny, streaky a žebříček.", live: true },
    { to: "/transfer-desk", label: "Transfer Desk", icon: Storefront, text: "Týdenní přestupová výzva — rozhodni jako manažer a sbírej body.", live: true },
    { to: "/worldcup", label: "World Cup '26", icon: Trophy, text: "MS 2026 skončilo — archiv: soupisky, výsledky Round Call výzev a statistiky.", live: true, archived: true },
    { to: "/fun/stat-battle", label: "Stat Battle", icon: Sword, text: "Kdo měl více bodů, asistencí, bonusů? Souboj statistik dvou hráčů.", live: true },
    { to: "/fun/higher-lower", label: "Higher or Lower", icon: ArrowsDownUp, text: "Hádej, jestli má další hráč vyšší nebo nižší hodnotu statistiky.", live: true },
    { to: "/fun/price-guess", label: "Cenovka", icon: Tag, text: "Tipni aktuální cenu hráče v sezoně 26/27 podle loňských statistik a rozhodni, jestli má value. 3 obtížnosti.", live: true },
    { to: "/scout", label: "Scout Challenge", icon: Binoculars, text: "Vyhledej hráče na Recruitment Focus ostatních manažerů — +1 XP za tip, komunitní žebříčky.", live: true },
];

export default function Fun() {
    return (
        <AppShell>
            <div data-testid="fun-page" className="max-w-5xl mx-auto space-y-8">
                <header>
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-fa-yellow">Fun</div>
                    <h1 className="font-display font-black uppercase tracking-tight text-2xl md:text-3xl mt-1 flex items-center gap-2">
                        <GameController size={26} className="text-fa-yellow" /> Hry & soutěže
                    </h1>
                    <p className="font-mono text-[10px] text-white/50 mt-2 max-w-2xl">
                        Otestuj své znalosti Premier League a FPL. Hry přidělují Knowledge XP — oddělené od Manager Ratingu za predikce.
                    </p>
                </header>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="fun-games">
                    {GAMES.map((g) => g.live ? (
                        <Link key={g.label} to={g.to}
                              className="border border-white/10 bg-black/40 p-5 space-y-2 hover:border-fa-yellow/50 transition-colors group"
                              data-testid={`fun-game-${g.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                            <g.icon size={22} className={g.archived ? "text-white/40" : "text-fa-yellow"} />
                            <div className="font-display font-bold uppercase text-sm group-hover:text-fa-yellow transition-colors flex items-center gap-2">
                                {g.label}
                                {g.archived && <span className="font-mono text-[8px] px-1.5 py-0.5 border border-white/25 text-white/45 tracking-widest">ARCHIV</span>}
                            </div>
                            <p className="font-mono text-[10px] text-white/55 leading-relaxed">{g.text}</p>
                        </Link>
                    ) : (
                        <div key={g.label} className="border border-white/5 bg-black/20 p-5 space-y-2 opacity-60"
                             data-testid={`fun-game-${g.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                            <g.icon size={22} className="text-white/40" />
                            <div className="font-display font-bold uppercase text-sm flex items-center gap-2">
                                {g.label}
                                <span className="font-mono text-[8px] px-1.5 py-0.5 border border-white/20 text-white/40">BRZY</span>
                            </div>
                            <p className="font-mono text-[10px] text-white/40 leading-relaxed">{g.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </AppShell>
    );
}
